export class ScrollLock{}

/**
 * 
 */
ScrollLock.lock = function(){
    document.documentElement.classList.add('ar-suppress-scroll');
};
/**
 *
 */
ScrollLock.release = function(){
    document.documentElement.classList.remove('ar-suppress-scroll');
};
/**
 *
 */
ScrollLock.toggle = function(){
    document.documentElement.classList.toggle('ar-suppress-scroll');
};